import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable class-methods-use-this */
import awaitCondition from '../utils/awaitCondition';
import ONETRUST from './OneTrustConstants';

var OneTrustClient = /*#__PURE__*/function () {
  function OneTrustClient() {
    _classCallCheck(this, OneTrustClient);
  }

  _createClass(OneTrustClient, [{
    key: "getPrivacyPreference",

    /**
     * Get the privacy preference value based on OneTrust consent requirement
     *
     * @See
     * https://my.onetrust.com/s/article/UUID-66bcaaf1-c7ca-5f32-6760-c75a1337c226?language=en_US
     */
    value: function () {
      var _getPrivacyPreference = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", awaitCondition(function () {
                  return window.OneTrust;
                }).then(function () {
                  if (_this.consentIsGiven(ONETRUST.CATEGORIES.PERFORMANCE)) {
                    return 'all';
                  }

                  return 'minimal';
                }).catch(function () {
                  return 'minimal';
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getPrivacyPreference() {
        return _getPrivacyPreference.apply(this, arguments);
      }

      return getPrivacyPreference;
    }()
    /**
     * Sets OneTrust notice active translations based on the web-store's
     * current locale. Should be called once OneTrust has loaded else it will have no effect.
     * Language code should be all lowercase.
     *
     * ## Usage -
     * `
     * oneTrustClient = new OneTrustClient();
     * oneTrustClient.setBannerTranslation('en');
     * `
     * @see {activateTranslations(langIsoCode)}
     * https://community.crownpeak.com/t5/Headless-Consent-CaaS/The-Consent-Platform-UCP-JavaScript-API-Documentation/ta-p/7647#:~:text=activateTranslations(code)
     *
     */

  }, {
    key: "setBannerTranslation",
    value: function () {
      var _setBannerTranslation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(langIsoCode) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", awaitCondition(function () {
                  return window.OneTrust;
                }).then(function () {
                  var _window$OneTrust, _window$OneTrust$getG;

                  if ((_window$OneTrust = window.OneTrust) === null || _window$OneTrust === void 0 ? void 0 : (_window$OneTrust$getG = _window$OneTrust.getGeolocationData().country) === null || _window$OneTrust$getG === void 0 ? void 0 : _window$OneTrust$getG.includes(langIsoCode)) return;
                  window.OneTrust.changeLanguage(langIsoCode);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function setBannerTranslation(_x) {
        return _setBannerTranslation.apply(this, arguments);
      }

      return setBannerTranslation;
    }()
  }, {
    key: "consentIsGiven",
    value: function consentIsGiven(consentCategory) {
      var _window$OnetrustActiv;

      return !!((_window$OnetrustActiv = window.OnetrustActiveGroups) === null || _window$OnetrustActiv === void 0 ? void 0 : _window$OnetrustActiv.includes(consentCategory));
    }
  }]);

  return OneTrustClient;
}();

export default OneTrustClient;